import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { tokenManager } from '@/shared/lib/storage';
import { getSessionStorage } from '@/shared/lib/storage/session-storage';
import { validateRedirectUrl } from '@/shared/lib/utils';

/**
 * 保護ルートレイアウト
 *
 * App層の責務:
 * - 認証チェック（beforeLoad）
 * - 未認証ユーザーのログインページへのリダイレクト
 * - 元のページへの戻りURL保存（オープンリダイレクト対策済み）
 */
export const Route = createFileRoute('/_protected')({
  beforeLoad: () => {
    // 認証チェック
    if (!tokenManager.isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          // 元いたページをredirectパラメータとして保持（安全な相対パスのみ）
          redirect:
            validateRedirectUrl(window.location.pathname + window.location.search) || undefined,
        },
      });
    }

    // 初回ログイン（パスワード未変更）の場合はパスワード変更ページへ強制リダイレクト
    const user = useSessionStore.getState().user;
    if (user != null && !user.isFirstLoginCompleted) {
      // ブラウザ再起動後（sessionStorage が消えた状態）ではトークンをクリアしてログインからやり直させる
      // beforeLoad 内で queryClient.clear() を含む logout() を呼ぶと、
      // AuthProvider の /me クエリがエラーになり /404 に遷移するため、トークンクリアのみ行う
      if (!getSessionStorage('login-session-active')) {
        tokenManager.clearTokens();
        throw redirect({ to: '/login' });
      }
      throw redirect({ to: '/change-password' });
    }
  },
  component: () => <Outlet />,
});
